import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { Drawer, Button, Menu } from "antd";
import "./Header.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { faBell } from "@fortawesome/free-regular-svg-icons";

const MenuItems = ({ mode = "inline" }) => {
  const menuItems = [
    {
      key: "products",
      label: "Products",
      children: [
        { label: "Hospitalization Cover", key: "Hospitalization Cover" },
        { label: "Personal Accident cover", key: "Personal Accident cover" },
        { label: "Critical Illness Cover", key: "Critical Illness Cover" },
        { label: "Daily Hospital Cash", key: "Daily Hospital Cash" },
        { label: "Riders", key: "Riders" },
        { label: "Group Insurance", key: "Group Insurance" },
      ],
    },
    {
      key: "claims",
      label: "Claims",
    },
    {
      key: "renewal",
      label: "Renewal",
      children: [
        { label: "Retail Customer", key: "retail" },
        { label: "Group Customer", key: "group" },
      ],
    },
    {
      key: "learn",
      label: "Learn",
      children: [
        { label: "Understand", key: "Understand" },
        { label: "Knowledge Bank", key: "Knowledge Bank" },
        { label: "FAQs", key: "FAQs" },
        { label: "MCHI Podcast", key: "MCHI Podcast" },
        { label: "Glossary", key: "Glossary" },
        { label: "Coverage Calculator", key: "Coverage Calculator" },
        { label: "Get Recommendation", key: "Get Recommendation" },
        { label: "Income Tax Calculator", key: "Income Tax Calculator" },
      ],
    },
    {
      key: "wellness",
      label: "Wellness",
      children: [
        { label: "Proactive Living", key: "Proactive Living" },
        { label: "Wellness Bites", key: "Wellness Bites" },
        { label: "Health Conditions Guide", key: "Health Conditions Guide" },
        { label: "Expert Opinion", key: "Expert Opinion" },
      ],
    },
    {
      key: "aboutus",
      label: "About Us",
      children: [
        { label: "About ManipalCigna", key: "About ManipalCigna" },
        { label: "Our Team", key: "Our Team" },
        { label: "Newsroom", key: "Newsroom" },
        { label: "Careers", key: "Careers" },
        { label: "Become an Agent", key: "Become an Agent" },
      ],
    },
    {
      key: "support",
      label: "Support",
      children: [
        { label: "Help Center", key: "Help Center" },
        { label: "Contact Us", key: "Contact Us" },
        { label: "Download Forms", key: "Download Forms" },
        { label: "Important Update", key: "Important Update" },
        { label: "Service Request", key: "Service Request" },
      ],
    },
  ];
  const onMenuClick = (event) => {
    const { key } = event;
    let redirectUrl = "";
    if (key === "products") {
      redirectUrl = "https://www.manipalcigna.com/health-insurance";
    } else if (key === "claims") {
      redirectUrl = "https://www.manipalcigna.com/claims";
    } else if (key === "retail") {
      redirectUrl = "https://online.manipalcigna.com/erenewal/";
    } else if (key === "group") {
      redirectUrl = "https://online.manipalcigna.com/erenewal/";
    } else if (key === "learn") {
      redirectUrl = "https://www.manipalcigna.com/learn";
    } else if (key === "wellness") {
      redirectUrl = "https://www.manipalcigna.com/wellness";
    } else if (key === "aboutus") {
      redirectUrl = "https://www.manipalcigna.com/about-manipalcigna";
    } else if (key === "support") {
      redirectUrl = "https://www.manipalcigna.com/help-centre";
    } else if (key === "Hospitalization Cover") {
      redirectUrl = "https://www.manipalcigna.com/hospitalization-cover";
    } else if (key === "Personal Accident cover") {
      redirectUrl = "https://www.manipalcigna.com/personal-accident-cover";
    } else if (key === "Personal Accident cover") {
      redirectUrl = "https://www.manipalcigna.com/personal-accident-cover";
    } else if (key === "Critical Illness Cover") {
      redirectUrl = "https://www.manipalcigna.com/critical-illness-cover";
    } else if (key === "Daily Hospital Cash") {
      redirectUrl = "https://www.manipalcigna.com/daily-hospital-cash";
    } else if (key === "Riders") {
      redirectUrl = "https://www.manipalcigna.com/riders";
    } else if (key === "Group Insurance") {
      redirectUrl = "https://www.manipalcigna.com/group-insurance";
    } else if (key === "Understand") {
      redirectUrl = "https://www.manipalcigna.com/learn/expert-speak";
    } else if (key === "Knowledge Bank") {
      redirectUrl = "https://www.manipalcigna.com/blog";
    } else if (key === "FAQs") {
      redirectUrl = "https://www.manipalcigna.com/faqs/products";
    } else if (key === "MCHI Podcast") {
      redirectUrl =
        "https://www.manipalcigna.com/podcast/financial-vaccination";
    } else if (key === "Glossary") {
      redirectUrl = "https://www.manipalcigna.com/learn/glossary";
    } else if (key === "Coverage Calculator") {
      redirectUrl = "https://www.manipalcigna.com/coverage-calculator";
    } else if (key === "Get Recommendation") {
      redirectUrl = "https://www.manipalcigna.com/get-recommendations";
    } else if (key === "Income Tax Calculator") {
      redirectUrl = "https://www.manipalcigna.com/income-tax-calculator";
    } else if (key === "Proactive Living") {
      redirectUrl = "https://wellbeing.manipalcigna.com/Account/Login";
    } else if (key === "Wellness Bites") {
      redirectUrl = "https://www.manipalcigna.com/wellness/wellness-bites";
    } else if (key === "Health Conditions Guide") {
      redirectUrl =
        "https://www.manipalcigna.com/wellness/manage-health-conditions";
    } else if (key === "Expert Opinion") {
      redirectUrl = "https://www.manipalcigna.com/wellness/expert-opinion";
    } else if (key === "About ManipalCigna") {
      redirectUrl = "https://www.manipalcigna.com/about-manipalcigna";
    } else if (key === "Our Team") {
      redirectUrl = "https://www.manipalcigna.com/board-members";
    } else if (key === "Newsroom") {
      redirectUrl = "https://www.manipalcigna.com/press-releases";
    } else if (key === "Careers") {
      redirectUrl = "https://www.manipalcigna.com/careers";
    } else if (key === "Become an Agent") {
      redirectUrl = "https://www.manipalcigna.com/become-an-agent";
    } else if (key === "Help Center") {
      redirectUrl = "https://www.manipalcigna.com/help-centre";
    } else if (key === "Contact Us") {
      redirectUrl = "https://www.manipalcigna.com/contact-us";
    } else if (key === "Download Forms") {
      redirectUrl = "https://www.manipalcigna.com/downloads/products";
    } else if (key === "Important Update") {
      redirectUrl = "https://www.manipalcigna.com/coronavirus-covid-19";
    } else if (key === "Service Request") {
      redirectUrl = "https://www.manipalcigna.com/service-request";
    }
    window.location.href = redirectUrl;
  };

  return (
    <div className="header_navigation-items">
      <Menu
        defaultSelectedKeys={[]}
        mode={mode}
        items={menuItems}
        onClick={onMenuClick}
      ></Menu>
    </div>
  );
};

const Header = (props) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  // const storeState = useSelector((state) => {
  //   return { login: state.common.login };
  // });

  let toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };

  let onClose = () => {
    setDrawerVisible(false);
  };
  useEffect(() => {
    if (drawerVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "inherit";
    }
  }, [drawerVisible]);

  return (
    <div className="header">
      <div className="mc-first-menu container">
        <ul>
          <li className="mc_telephone hidden-xs">
            <a href="tel:1800-102-4465">
              <span>
                <span className="t_hide">To Renew : </span>
                <FontAwesomeIcon icon={faPhone} />
                <span className="t_hide">1800 102 4465</span>
              </span>
            </a>
          </li>
          <li className="mc_telephone hidden-xs">
            <a href="tel:1800 102 4462">
              <span>
                <span className="t_hide">For Service: </span>
                <FontAwesomeIcon icon={faPhone} />
                <span className="t_hide">1800 102 4462</span>
              </span>
            </a>
          </li>
          <li className="mc_telephone">
            <a href="tel:1800-102-4464">
              <span>
                <span className="t_hide">To Buy : </span>
                <FontAwesomeIcon icon={faPhone} />
                <span className="t_hide">1800 102 4464</span>
              </span>
            </a>
          </li>
          <li className="mc_telephone">
            <a
              href="https://buyonline.manipalcigna.com/buy-health-insurance/Group-Insurance"
              className="text-white"
            >
              <span className="border-left-desktop">
                <span
                  className="t_hide"
                  style={{
                    padding: "0 5px 0px 15px",
                  }}
                >
                  Groups
                </span>
                <FontAwesomeIcon icon={faBell} />
              </span>
            </a>
          </li>
        </ul>
        {/* {storeState.login === "" ||
          (storeState.login === undefined && ( */}
        <div className="mc_log_c_b">
          <div className="mc_l_l">
            <a href={"https://eservicing.manipalcigna.com/"}>Login</a>
          </div>
        </div>
        {/* ))} */}
      </div>
      <div className="header__navigation">
        <div className="container">
          <div className="header-inner-navigation">
            <div className="header-logo">
              <a href={"https://www.manipalcigna.com/"}>
                <img src="/logo.png" />
              </a>
            </div>
            <div className="desktop-menu">
              <MenuItems mode="horizontal" />
            </div>
            <Button
              id="mc_nav_icon"
              className={`bars-menu ${drawerVisible ? "mc_open" : ""}`}
              type="link"
              onClick={toggleDrawer}
            >
              <span></span>
              <span></span>
              <span></span>
            </Button>
            <Drawer
              placement="right"
              closable={false}
              onClose={onClose}
              visible={drawerVisible}
              mask={false}
              className={"mchi-mobile-menu"}
            >
              <MenuItems />
            </Drawer>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
